// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { stringifyXML, parseXML } from "./xml.js";
export { XML_ATTRKEY, XML_CHARKEY, type XmlOptions } from "./xml.common.js";
